import { z } from 'zod';

export const MenuItem = z.object({
  id: z.string(),
  label: z.string().transform((rawLabel) => {
    const label = rawLabel.trim().toLowerCase();

    // NOTE: These should probably be fixed on the backend
    const exceptions: Record<string, string> = {
      ai: 'AI',
      'c-suite': 'C-Suite',
      'ceo initiative': 'CEO Initiative',
      'fortune sea 500': 'Fortune SEA 500',
    };

    if (label in exceptions) {
      return exceptions[label];
    }

    return label
      ? label
          .split(/\s+/)
          .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ''))
          .join(' ')
      : '';
  }),
  parentId: z.string().nullable(),
  url: z
    .string()
    .nullish()
    .transform(async (url) => url ?? ''),
});

export const Menu = z.object({
  menus: z.object({
    nodes: z.array(
      z.object({
        menuItems: z.object({
          nodes: z.array(MenuItem),
        }),
      }),
    ),
  }),
});

export type Menu = z.infer<typeof Menu>;
export type MenuItem = z.infer<typeof MenuItem>;
